export const projectSortOptions = [
    { value: "name", label: "Name" },
    { value: "-name", label: "Name (desc)" },
    { value: "$modified", label: "Modified" },
    { value: "-$modified", label: "Modified (desc)" },
    { value: "$created", label: "Created" },
    { value: "-$created", label: "Created (desc)" },
]
